import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MessageTemplateCreatorPopoverComponent } from './MessageTemplateCreatorPopoverComponent';

/**
 * MessageTemplateCreatorModule
 * メッセージテンプレート作成機能のスタンドアロンモジュール
 */
@NgModule({
  declarations: [
    MessageTemplateCreatorPopoverComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
  exports: [
    MessageTemplateCreatorPopoverComponent
  ]
})
export class MessageTemplateCreatorModule { }
